import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import ProductRow from './ProductRow';
import ErrorBoundary from 'components/common/ErrorBoundary';

/**
 * Tabla de productos de la orden
 */
const ProductosTable = ({
    ordenDetalles,
    orden,
    showEditarPrecios,
    editedProducts,
    handleProductChange,
    obtenerLicenciasParaModal,
    setseguroStateEliminar,
    idCatTipoUsuario,
    onPlanAsociado,
    productoTimbres
}) => {
    return (
        <ErrorBoundary>
            <Table striped className="border-bottom">
                <thead className="bg-100 text-900">
                    <tr>
                        <th className="border-0">IMAGEN</th>
                        <th className="border-0">C&oacute;d. Barras</th>
                        <th className="border-0">Nombre Producto</th>
                        <th className="border-0 text-center">Cantidad</th>
                        <th className="border-0 text-end">Prec. Unit.</th>
                        <th className="border-0 text-end">Importe</th>
                        <th className="border-0 text-end">I.V.A.</th>
                        <th className="border-0 text-end">Total</th>
                    </tr>
                </thead>
                <tbody>
                    {ordenDetalles.map((product, idx) => (
                        <ProductRow
                            key={product.idOrdenDetalle || idx}
                            product={product}
                            orden={orden}
                            showEditarPrecios={showEditarPrecios}
                            editedProducts={editedProducts}
                            handleProductChange={handleProductChange}
                            obtenerLicenciasParaModal={obtenerLicenciasParaModal}
                            setseguroStateEliminar={setseguroStateEliminar}
                            idCatTipoUsuario={idCatTipoUsuario}
                            onPlanAsociado={onPlanAsociado}
                            productoTimbres={productoTimbres}
                        />
                    ))}
                </tbody>
            </Table>
        </ErrorBoundary>
    );
};

ProductosTable.propTypes = {
    ordenDetalles: PropTypes.array.isRequired,
    orden: PropTypes.object.isRequired,
    showEditarPrecios: PropTypes.bool.isRequired,
    editedProducts: PropTypes.object.isRequired,
    handleProductChange: PropTypes.func.isRequired,
    obtenerLicenciasParaModal: PropTypes.func.isRequired,
    setseguroStateEliminar: PropTypes.func.isRequired,
    idCatTipoUsuario: PropTypes.string.isRequired,
    onPlanAsociado: PropTypes.func,
    productoTimbres: PropTypes.number
};

export default ProductosTable;
